import React, { useRef } from "react";
import styled from "styled-components";
import Draggable from "react-draggable";
import { useEffect } from "react";
import anime from "animejs";

const Wrap = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
`;

const BasketShape = styled.div`
  position: relative;
  width: 555px;
  height: 528px;
  background: url(${require("@assets/img/donutgame/basket.png")}) no-repeat;
`;

const BasketCard = styled.div`
  position: absolute;
  width: 360px;
  height: 260px;
  box-sizing: border-box;
  border: 10px solid #ccc;
  background-color: #fff;
  left: 92px;
  bottom: 15px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  > img {
    height: 95%;
  }
  pointer-events: none;
`;

const AnswerWrap = styled.div`
  pointer-events: none;
  position: absolute;
  left: 45px;
  width: 460px;
  top: 180px;
  overflow: hidden;
  height: 54px;
  &.max1 {
    .inner-img {
      + .inner-img {
        margin-left: -135px;
      }
    }
  }
  &.max2 {
    .inner-img {
      + .inner-img {
        margin-left: -155px;
      }
    }
  }

  .inner-img {
    + .inner-img {
      margin-left: -110px;
    }
  }
`;

const AnswerImg = styled.img`
  position: relative;
  left: 0;
  top: 0;
  width: 165px;
  height: 165px;
`;

const NumCircle = styled.div`
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 10px solid #fff;
  background-color: #ef6d77;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  margin-left: -80px;
  margin-top: -60px;
  box-sizing: border-box;
  opacity: 0;
  > span {
    font-size: 80px;
    font-weight: bold;
    margin-top: 10px;
    display: block;
  }
`;

const EffectWrap = styled.div`
  position: absolute;
  width: 200px;
  height: 200px;
  left: 173px;
  top: 282px;
`;

const EffectImg = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  &.a-o {
    background: url(${require("@assets/img/activity_answer_o.png")}) no-repeat;
    background-size: cover;
  }
  &.a-x {
    background: url(${require("@assets/img/activity_answer_x.png")}) no-repeat;
    background-size: cover;
  }

  &.on {
    animation: scaleInOut 1s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
`;

const Basket = ({
  onPass,
  onFail,
  currentWord,
  isComplete,
  currentImg,
  answerImgs,
}) => {
  const ref = useRef();

  useEffect(() => {
    const aO = document.querySelector(".a-o");
    const aX = document.querySelector(".a-x");
    window.__cardGameEffectFunc = (isCorrect) => {
      const effectTarget = isCorrect ? aO : aX;
      effectTarget.classList.remove("on");
      // eslint-disable-next-line no-unused-vars
      const a = effectTarget.offsetHeight;
      effectTarget.classList.add("on");
    };
    return () => {
      window.__cardGameEffectFunc = null;
    };
  }, []);

  useEffect(() => {
    const wrap = document.querySelector("#aaaWrap");
    if (answerImgs.length > 6) {
      wrap.classList.add("max1");
    } else if (answerImgs.length >= 10) {
      wrap.classList.add("max2");
    }

    if (answerImgs.length > 0) {
      anime({
        targets: "#numCircle",
        duration: 500,
        easing: "easeOutCubic",
        keyframes: [
          { opacity: 0, translateY: 150 },
          { opacity: 1, translateY: 0 },
          { opacity: 0, translateY: 150, easing: "easeInCubic", duration: 500 },
        ],
      });
    }
  }, [answerImgs]);

  useEffect(() => {
    anime({
      targets: document.querySelector(".bCard"),
      opacity: [0, 1],
      scale: [1.1, 1],
    });
  }, [currentImg]);

  useEffect(() => {
    if (isComplete) {
      document.querySelector("#basket").style.opacity = 0;
    } else {
      document.querySelector("#basket").style.opacity = 1;
    }
  }, [isComplete]);

  return (
    <Draggable
      axis="x"
      defaultPosition={{ x: 655, y: 0 }}
      position={null}
      scale={window.__scale}
      bounds="parent"
      nodeRef={ref}
    >
      <Wrap ref={ref} id="basket">
        <BasketShape>
          <NumCircle id="numCircle">
            <span>+1</span>
          </NumCircle>
          {currentImg && (
            <BasketCard className="bCard">
              <img src={currentImg} alt="" />
            </BasketCard>
          )}

          <AnswerWrap id="aaaWrap">
            {answerImgs &&
              answerImgs.map((img, i) => {
                return (
                  <AnswerImg className="inner-img" key={i} src={img} alt="" />
                );
              })}
          </AnswerWrap>
          <EffectWrap>
            <EffectImg className="a-o" />
            <EffectImg className="a-x" />
          </EffectWrap>
        </BasketShape>
      </Wrap>
    </Draggable>
  );
};

export default Basket;
